<template>
  <v-card>
    <v-card-text>
      <v-data-table
        @click:row="rowClick"
        single-select
        show-select
        v-model="selectionModel"
        dense
        v-on:item-selected="updateSelection"
        :headers="productSettingHeaders"
        :items="admin.productSettingList"
        :items-per-page="15"
        no-data-text="NONE"
        :hide-default-footer="admin.productSettingList.length == 0"
        :hide-default-header="admin.productSettingList.length == 0"
      >
        <template v-slot:item.attributeId="{ item }">
          {{ getAttributeName(item.attributeId) }}
        </template>
        <template v-slot:item.published="{ item }">
          <v-icon color="success" v-show="item.published">mdi-check</v-icon>
        </template>
      </v-data-table>
    </v-card-text>
    <v-card-actions>
      <v-spacer />
      <v-btn dark color="blue darken-2" @click="addNewProductSetting"
        ><v-icon>mdi-plus</v-icon> ADD NEW</v-btn
      >
    </v-card-actions>
  </v-card>
</template>

<script>
  import { mapState } from 'vuex';

  export default {
    data() {
      return {
        productSettingHeaders: [
          { text: 'ID', value: 'id', width: '80px' },
          { text: 'ATTRIBUTE', value: 'attributeId' },
          { text: 'LABEL', value: 'label' },
          { text: 'VALUE SUFFIX', value: 'valueSuffix' },
          { text: 'PUBLISHED', value: 'published' }
        ]
      };
    },
    computed: {
      ...mapState(['app', 'admin']),
      selectionModel: {
        get() {
          return this.admin.selectedProductSettingSelectionModel;
        },
        set(value) {
          this.$store.commit('admin/setSelectionModel', {
            entity: 'selectedProductSettingSelectionModel',
            value: value
          });
          this.$store.dispatch('admin/getProductSettingList');
        }
      }
    },
    methods: {
      /**
       * returns the description for given productId
       */
      getAttributeName(attributeId) {
        return this.admin.attributeList.find((x) => x.id == attributeId)?.name;
      },
      /**
       * Handles row click
       */
      rowClick: function (item, row) {
        row.select(!row.isSelected);
      },
      /**
       * Adds a new Product Attribute to currently selected product
       */
      addNewProductSetting() {
        this.$store.commit('admin/setSelectedProductSetting', {
          id: 'new',
          productId: this.admin.selectedProduct.id,
          attributeId: 0,
          label: '',
          valueSuffix: '',
          published: false
        });
        // clear selection models
        this.clearThisSelectionModel();
      },
      /**
       * Fires when an item is selected in the data table
       */
      updateSelection(data) {
        if (data.value) {
          this.$store.commit('admin/setSelectedProductSetting', data.item);
        } else {
          this.$store.commit('admin/setSelectedProductSetting', null);
        }
        this.clearChildSelectionModels();
      },
      /**
       * Clears this components selection model
       */
      clearThisSelectionModel() {
        this.$store.commit('admin/setSelectionModel', {
          entity: 'selectedProductSettingSelectionModel',
          value: null
        });
      },
      /**
       * Clears Child Selection Models
       */
      clearChildSelectionModels() {
        // placeholder
      }
    }
  };
</script>
